import React from "react";
import {Row, Col, Button, Radio, Modal, Pagination, Alert} from "antd";
import {displayError, displayGenericError} from "common/notifications";
import {
    getBeneficiaries,
    saveOriginator,
    saveBeneficiary,
    getCurrencyCountry,
    getIdType, getCountryList, getOriginatorsBySenderType
} from "api/api";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import LoadingIndicator from "components/LoadingIndicator";
import SelectableRadioPanel from "components/SelectableRadioPanel";
import BeneficiaryModal from "components/modal/BeneficiaryModal";
import "./SetupBeneficiaryTab.scss";
import BeneficiaryDetailsPanel from "components/BeneficiaryDetailsPanel";
import { formatMoneyValue, formatMoney, formatExchangeRate } from "utils/utils";
import {DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE_5} from "../../common/Const";
import OriginatorDetailsPanel from "../../components/OriginatorDetailsPanel";
import CustomerAccountDetailsPanel from "../../components/CustomerAccountDetailsPanel";
import OriginatorModal from "../../components/modal/OriginatorModal";
import BeneficiaryAddressModal from "../../components/modal/BeneficiaryAddressModal";
import OriginatorSelectionComponent from "../../components/OriginatorSelectionComponent";
import BeneficiarySelectionComponent from "../../components/BeneficiarySelectionComponent";
import {getBeneficiariesByOriginator, getIndustryCode, getTransactionLimitations} from "../../api/api";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import {displayNumberWithComma} from "../../utils/utils";
import {getCountries} from "react-phone-number-input";

import HorizontalLine from 'components/graphics/HorizontalLine';

const { confirm } = Modal

const RadioGroup = Radio.Group;

class SetupBeneficiaryTab extends React.Component {
  state = {
    isLoading: true,
    isBeneficiaryLoading: false,
    isBeneficiaryModalVisible: false,
      isBeneficiaryAddressModalVisible: false,
    isOriginatorModalVisible: false,
    newBeneficiary: {},
    originators:[],
    industries:[],
    newOriginator: {},
      countries:[],
    idTypes:[],
    senderUsingCustomerAccount: false,
    selectedBeneficiary: null,
      selectedBeneficiaryVAId: null,
    selectedOriginator: null,
    selectedOriginatorVAId: null,
    validBankCountryList: [],
    currentPageBeneficiary: DEFAULT_PAGE_NO,
    currentPageOriginator: DEFAULT_PAGE_NO,
    transactionLimitation:{},
      transactionLimitations:[],
      disabledAll:false,
    beneficiaryFromOriginator:false,
      warningMsgCcy:''
  };

  componentDidMount() {
    this.refreshBeneficiariesList();
    if(this.props.currentCustomer.isPartner) {
        this.refreshOriginatorsList();
    }
    getCurrencyCountry().then(responseCountry => {
      let validBankCountryList;
      validBankCountryList = responseCountry
        .filter(country => country.currency === this.props.currency)
        .map(item =>{
          return item.countryCode;
        });

      this.setState({
        validBankCountryList:validBankCountryList
      })
    });
      getIdType().then(response => {
          this.setState({
              idTypes: response
          });
      }).catch(error => {
          displayGenericError(error);
      });
      getIndustryCode().then(response => {
          this.setState({
              industries: response
          });
      }).catch(error => {
          displayGenericError(error);
      });
      const intl = this.props.useIntl;
      getTransactionLimitations().then(response => {
          if(response && response.length>0) {
              let transactionLimitations = response.filter(s => s.currency === this.props.payment.targetValue.currency);
              if(transactionLimitations[0]) {
              this.setState({
                  transactionLimitation: transactionLimitations[0],
                  transactionLimitations: response,
                  disabledAll: false
              })
              }else {
                  setTimeout(()=>{
                      alert(intl.formatMessage({id:"app.message.setupbeneficiarytab.no.transactionLimit"}));
                  },500)

                  this.setState({
                      disabledAll: true
                  })
              }
          }
      }).catch(error => {

      });

      getCountryList().then(res=>{
          this.setState({
              countries: res
          });
      })
  }

  submitBeneficiary = beneficiary => {
    saveBeneficiary(beneficiary)
    .then(response => {
      this.closeBeneficiaryModal();
      if(this.state.selectedOriginator && this.state.selectedOriginator.id) {
          let beneficiaryType =  this.props.payment.beneficiaryType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';
          if(!this.props.payment.displaySelectBeneficiaryType){
              beneficiaryType = null;
          }
          getBeneficiariesByOriginator(this.state.selectedOriginator.id, this.state.currentPageBeneficiary,DEFAULT_PAGE_SIZE_5, beneficiaryType, this.props.payment.beneficiaryCountry, this.props.payment.sourceValue.currency,this.props.payment.targetValue.currency)
              .then(response => {
                  this.setState({
                      beneficiaries: response.content,
                      beneficiariesTotal: response.totalElements,
                      isLoading: false
                  });
              })
              .catch(error => {
                  this.setState({
                      beneficiaries: [],
                      isLoading: false
                  });
                  displayGenericError(error);
              });
      } else {
          this.refreshBeneficiariesList();
      }
      })
      .catch(error => {
        displayGenericError(error);
      });
  };
    submitOriginator = originator => {
        this.closeOriginatorModal();
        this.refreshOriginatorsList();
    };

  getNextBeneficiaryPage = async (nextPage) => {
    this.setState({
      isLoading: true
    });
    if(!this.state.beneficiaryFromOriginator || this.state.senderUsingCustomerAccount){
        let beneficiaryType =  this.props.payment.beneficiaryType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';
        if(!this.props.payment.displaySelectBeneficiaryType){
            beneficiaryType = null;
        }
        getBeneficiaries(nextPage,DEFAULT_PAGE_SIZE_5, beneficiaryType, this.props.payment.beneficiaryCountry, this.props.payment.sourceValue.currency,this.props.payment.targetValue.currency)
            .then(response => {
                this.setState({
                    currentPageBeneficiary: nextPage,
                    beneficiaries: response.content,
                    beneficiariesTotal: response.totalElements,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    beneficiaries: [],
                    isLoading: false
                });
                displayGenericError(error);
            });
    }else{
        let beneficiaryType =  this.props.payment.beneficiaryType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';
        if(!this.props.payment.displaySelectBeneficiaryType){
            beneficiaryType = null;
        }
        getBeneficiariesByOriginator(this.state.selectedOriginator.id, nextPage, DEFAULT_PAGE_SIZE_5, beneficiaryType, this.props.payment.beneficiaryCountry,  this.props.payment.sourceValue.currency,this.props.payment.targetValue.currency)
            .then(response => {
                this.setState({
                    currentPageBeneficiary: nextPage,
                    beneficiaries: response.content,
                    beneficiariesTotal: response.totalElements,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    beneficiaries: [],
                    isLoading: false
                });
                displayGenericError(error);
            });
    }

  }

    getNextOriginatorPage = async (nextPage) => {
        this.setState({
            isLoading: true
        });
        let senderType =  this.props.payment.senderType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';
        if(!this.props.payment.displaySelectSenderType){
            senderType = null;
        }
        getOriginatorsBySenderType(nextPage,DEFAULT_PAGE_SIZE_5, senderType)
            .then(response => {
                this.setState({
                    currentPageOriginator: nextPage,
                    originators: response.content,
                    originatorsTotal: response.totalElements,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    originators: [],
                    isLoading: false
                });
                displayGenericError(error);
            });
    }

  refreshBeneficiariesList = () => {
    this.setState({
      currentPageBeneficiary: DEFAULT_PAGE_NO,
      isBeneficiaryLoading: true
    });
    let beneficiaryType =  this.props.payment.beneficiaryType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';

      if(!this.props.payment.displaySelectBeneficiaryType){
          beneficiaryType = null;

      }
    getBeneficiaries(this.state.currentPageBeneficiary,DEFAULT_PAGE_SIZE_5, beneficiaryType, this.props.payment.beneficiaryCountry, this.props.payment.sourceValue.currency,this.props.payment.targetValue.currency)
      .then(response => {
        this.setState({
          beneficiaries: response.content,
          beneficiariesTotal: response.totalElements,
          isBeneficiaryLoading: false,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          beneficiaries: [],
          isBeneficiaryLoading: false,
          isLoading: false
        });
        displayGenericError(error);
      });
  };

    refreshOriginatorsList = () => {
        this.setState({
            currentPageOriginator: DEFAULT_PAGE_NO,
            isLoading: true
        });
        let senderType =  this.props.payment.senderType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';
        if(!this.props.payment.displaySelectSenderType){
            senderType = null;
        }
        getOriginatorsBySenderType(this.state.currentPageOriginator,DEFAULT_PAGE_SIZE_5, senderType)
            .then(response => {
                this.setState({
                    originators: response.content,
                    originatorsTotal: response.totalElements,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    originators: [],
                    isLoading: false
                });
                displayGenericError(error);
            });
    };

    onFieldChanged = (fieldName, newValue) => {
        this.setState({
          [fieldName]: newValue
        })
    
      };

  onAddBeneficiaryClicked = () => {
    let selectedBeneficiary = this.state.selectedBeneficiary;
    this.setState({
      isBeneficiaryModalVisible: true,
        selectedBeneficiary: null
    });
  };

    onAddOriginatorClicked = () => {
        this.setState({
            isOriginatorModalVisible: true
        });
    };

  closeBeneficiaryModal = () => {
    this.setState({
      isBeneficiaryModalVisible: false
    });
  };
    closeBeneficiaryAddressModal=()=>{
        this.setState({
            isBeneficiaryAddressModalVisible: false
        });
    }

    closeOriginatorModal = () => {
        this.setState({
            isOriginatorModalVisible: false,
            selectedOriginator: null
        });
    };
    validationTransactionLimitation = (transactionLimitation, beneficiaryType) => {
            let targetAmount = this.props.payment.targetValue.amount;
            if (targetAmount !== '' && this.props.currentCustomer != null) {
                if(beneficiaryType == "INDIVIDUAL"){
                    return {
                        result: targetAmount <= transactionLimitation.individualMax && targetAmount >= transactionLimitation.individualMin,
                        max: transactionLimitation.individualMax,
                        min: transactionLimitation.individualMin
                    };
                }else{
                    return {
                        result: targetAmount <= transactionLimitation.corporateMax && targetAmount >= transactionLimitation.corporateMin ,
                        max: transactionLimitation.corporateMax,
                        min: transactionLimitation.corporateMin
                    };
                }

            }

        return {result: true, max: ''};
    };

  onBeneficiarySelected = id => {
      const intl = this.props.useIntl;
    let beneficiary = this.state.beneficiaries.filter(b => b.id === id)[0];
    if(beneficiary.status === "B") {
        displayError(intl.formatMessage({id:"app.panel.setupbeneficiarytab.beneficiary-blocked"}))
        return;
    }
       let transactionLimitHasCountry = this.state.transactionLimitations.filter(s => s.currency === this.props.payment.targetValue.currency
           && s.targetCountry && s.targetCountry !== '' && s.targetCountry != null);
        let transactionLimitation = null;
        if(transactionLimitHasCountry){
             transactionLimitHasCountry = transactionLimitHasCountry.filter(s=>s.targetCountry === beneficiary.bankCountry)
            if(transactionLimitHasCountry && transactionLimitHasCountry[0]){
                transactionLimitation = transactionLimitHasCountry[0]
            }else{
                let transactionLimitNoCountry = this.state.transactionLimitations.filter(s => s.currency === this.props.payment.targetValue.currency
                    && (s.targetCountry == null || s.targetCountry === ''));
                if(transactionLimitNoCountry && transactionLimitNoCountry[0]){
                    transactionLimitation = transactionLimitNoCountry[0];

                }
            }
        }else{
            let transactionLimitNoCountry = this.state.transactionLimitations.filter(s => s.currency === this.props.payment.targetValue.currency
                && (s.targetCountry == null || s.targetCountry === ''));
            if(transactionLimitNoCountry && transactionLimitNoCountry[0]){
                transactionLimitation = transactionLimitNoCountry[0];

            }
        }
      if ((transactionLimitation && transactionLimitation != null ) && (transactionLimitation.txnLimitType == null || transactionLimitation.txnLimitType == "RECEIVER")) {
          let validationLimit = this.validationTransactionLimitation(transactionLimitation, beneficiary.beneficiaryType);
          let errorMsg = "";
          let msg = "";
          if(beneficiary.beneficiaryType == "INDIVIDUAL") {
              msg = intl.formatMessage({id: "app.panel.clienttransfercalculator.max.recipient.ind"});
          }else {
              msg = intl.formatMessage({id: "app.panel.clienttransfercalculator.max.recipient.corp"});
          }
          if (!validationLimit.result) {
              let currency = this.props.payment.targetValue.currency;
              msg = msg + displayNumberWithComma(validationLimit.min) + " - " + displayNumberWithComma(validationLimit.max);
              errorMsg = msg + " " + currency;
              this.setState({
                  errorMsgOverLimit: errorMsg
              });
              displayError(errorMsg);
              return;
          } else {
              this.setState({
                  errorMsgOverLimit: ''
              });
          }
      }

      if((transactionLimitation && transactionLimitation != null )  && (transactionLimitation.txnLimitType == "SENDER" && this.state.selectedOriginator)) {
          let validationLimit = this.validationTransactionLimitation(transactionLimitation, this.state.selectedOriginator.originatorType);

          let errorMsg = "";
          let msg = "";
          if(this.state.selectedOriginator.originatorType == "INDIVIDUAL") {
              msg =intl.formatMessage({id: "app.panel.clienttransfercalculator.max.sender.ind"});
          }else {
              msg =intl.formatMessage({id: "app.panel.clienttransfercalculator.max.sender.corp"});
          }
          if (!validationLimit.result) {
              let currency = this.props.payment.targetValue.currency;
              msg = msg + displayNumberWithComma(validationLimit.min) + " - " + displayNumberWithComma(validationLimit.max);
              errorMsg = msg + " " + currency;
              this.setState({
                  errorMsgOverLimit: errorMsg
              });
              displayError(errorMsg);
              return;
          } else {
              this.setState({
                  errorMsgOverLimit: ''
              });
          }
      }


      let countryHaveCcy = this.state.countries.find(item => item.localCurrency==this.props.payment.targetValue.currency);
      let warningMsgCcy='';
      if(countryHaveCcy) {
          if(beneficiary.bankCountry != countryHaveCcy.countryCode) {
              warningMsgCcy = intl.formatMessage({id: "app.panel.setupbeneficiarytab.target.ccy.not.in.local"}).replace('%localCurrency', countryHaveCcy.localCurrency);
          }
      }

      this.setState({
        selectedBeneficiary: beneficiary,
          warningMsgCcy:warningMsgCcy
      })
    //}
  };

    onOriginatorSelected = id => {
        const intl = this.props.useIntl;

        var originator = null;    
        if (id === 'SELF') {
            this.setState({
                senderUsingCustomerAccount: true
                //beneficiaryFromOriginator: false
            });
        } else {
            originator = this.state.originators.filter(b => b.id === id)[0];
            this.setState({
                senderUsingCustomerAccount: false
                //beneficiaryFromOriginator: true
            });
        }
        
        let transactionLimitation = this.state.transactionLimitation;

        if(transactionLimitation && transactionLimitation.txnLimitType == "SENDER") {
            let validationLimit = this.validationTransactionLimitation(transactionLimitation, 
                (originator) ? originator.originatorType : this.props.currentCustomer.accountType);

            let errorMsg = "";
            let msg = "";

            if (originator) {
                if (originator.originatorType == "INDIVIDUAL") {
                    msg =intl.formatMessage({id: "app.panel.clienttransfercalculator.max.sender.ind"});
                } else {
                    msg =intl.formatMessage({id: "app.panel.clienttransfercalculator.max.sender.corp"});
                }
            } else {
                if (this.props.currentCustomer.accountType == "PERSONAL") {
                    msg =intl.formatMessage({id: "app.panel.clienttransfercalculator.max.sender.ind"});
                } else {
                    msg =intl.formatMessage({id: "app.panel.clienttransfercalculator.max.sender.corp"});
                }
            }
            
            if (!validationLimit.result) {
                let currency = this.props.payment.targetValue.currency;
                msg = msg + displayNumberWithComma(validationLimit.min) + " - " + displayNumberWithComma(validationLimit.max);
                errorMsg = msg + " " + currency;
                this.setState({
                    errorMsgOverLimit: errorMsg
                });
                displayError(errorMsg);
                return;
            } else {
                this.setState({
                    errorMsgOverLimit: ''
                });
            }
        }

        this.setState({
            selectedOriginator: originator,
            warningMsgCcy:''
        })
        //if haven't select beneficiary and customer account partner like partner
        if(this.props.currentCustomer.isPartner){
            this.setState({
                isBeneficiaryLoading: true,
                beneficiaryFromOriginator:true,
                selectedBeneficiary: null,

            });
            let beneficiaryType =  this.props.payment.beneficiaryType === 'PERSONAL' ?  'INDIVIDUAL' : 'CORPORATE';
            if(!this.props.payment.displaySelectBeneficiaryType){
                beneficiaryType = null;
            }

            if (originator) {
                getBeneficiariesByOriginator(originator.id, this.state.currentPageBeneficiary,DEFAULT_PAGE_SIZE_5, beneficiaryType,this.props.payment.beneficiaryCountry,  this.props.payment.sourceValue.currency,this.props.payment.targetValue.currency)
                    .then(response => {
                        this.setState({
                            beneficiaries: response.content,
                            beneficiariesTotal: response.totalElements,
                            isBeneficiaryLoading: false,
                            isLoading: false
                        });
                    })
                    .catch(error => {
                        this.setState({
                            beneficiaries: [],
                            isBeneficiaryLoading: false,
                            isLoading: false
                        });
                        displayGenericError(error);
                    });
            } else {
                getBeneficiaries(this.state.currentPageBeneficiary,DEFAULT_PAGE_SIZE_5, beneficiaryType,this.props.payment.beneficiaryCountry, this.props.payment.sourceValue.currency,this.props.payment.targetValue.currency)
                    .then(response => {
                        this.setState({
                            beneficiaries: response.content,
                            beneficiariesTotal: response.totalElements,
                            isBeneficiaryLoading: false,
                            isLoading: false
                        });
                    })
                    .catch(error => {
                        this.setState({
                            beneficiaries: [],
                            isBeneficiaryLoading: false,
                            isLoading: false
                        });
                        displayGenericError(error);
                    });
            }
            

        }
        //}
        
    };
  onNextButtonClick =() =>{
      const intl = this.props.useIntl;
      let baseCurrency = this.props.currentCustomer.companyProfile.baseCurrency;
      let sourceCurrency = this.props.payment.sourceValue.currency;
      let sourceAmount = this.props.payment.sourceValue.amount;

      if(this.state.selectedOriginatorVAId && this.state.selectedOriginatorVAId>0) {
          let selectedOriginatorVA = this.state.selectedOriginator.virtualAccounts.find(item=> item.id===this.state.selectedOriginatorVAId);
          if(selectedOriginatorVA){
              let currentBal = 0;
              if(selectedOriginatorVA.vaBalanceStrClaimed) {
                  if(selectedOriginatorVA.vaBalanceStrClaimed[sourceCurrency]) {
                      currentBal = selectedOriginatorVA.vaBalanceStrClaimed[sourceCurrency];
                  }
              }

              if(currentBal < sourceAmount) {
                  displayError(intl.formatMessage({id:"app.panel.setupbeneficiarytab.not.enough.balance.va"}));
                return;
              }
          }
      }

      if((baseCurrency ==='HKD' || sourceCurrency === 'HKD') && (!this.state.selectedBeneficiary.addressLine1 && !this.state.selectedBeneficiary.addressLine2)){
          this.setState({
              isBeneficiaryAddressModalVisible:true
          })
      }else{
          this.props.onCompleted(this.state.selectedBeneficiary, this.state.selectedOriginator,this.state.selectedBeneficiaryVAId,this.state.selectedOriginatorVAId)
      }

  }
    onFinishSelectedAddress = (selectedBeneficiary) => {
        this.setState({selectedBeneficiary: selectedBeneficiary, isBeneficiaryAddressModalVisible: false}, () => {
            this.props.onCompleted(this.state.selectedBeneficiary, this.state.selectedOriginator,this.state.selectedBeneficiaryVAId,this.state.selectedOriginatorVAId)
        })
    }
  render() {
    const intl = this.props.useIntl;
    const {beneficiaries, isLoading, selectedBeneficiary,selectedBeneficiaryVAId, originators, selectedOriginator, senderUsingCustomerAccount } = this.state;
    if (isLoading) {
      return <LoadingIndicator />;
    }
      let disabledNext = selectedBeneficiary === null;
      if(this.props.currentCustomer.isPartner) {
        disabledNext = selectedBeneficiary === null || (selectedOriginator === null && !senderUsingCustomerAccount);
      }else if (this.state.errorMsgOverLimit){
          disabledNext=true;
      }
      let baseCurrency = this.props.currentCustomer.companyProfile.baseCurrency;
      let sourceCurrency = this.props.payment.sourceValue.currency;
      return (
      <>
        <BeneficiaryModal
            currency={this.props.currency}
            selectedOriginator={this.state.selectedOriginator}
            selectedBeneficiary={this.state.selectedBeneficiary}
            checkAddress={baseCurrency === 'HKD' || sourceCurrency==='HKD'}
            visible={this.state.isBeneficiaryModalVisible}
            industries={this.state.industries}
            currentCustomer={this.props.currentCustomer}
            onCompleted={this.submitBeneficiary}
            onCancel={this.closeBeneficiaryModal}
        />
          <BeneficiaryAddressModal visible={this.state.isBeneficiaryAddressModalVisible} beneficiaryId={selectedBeneficiary&&selectedBeneficiary.id}
                                   onCancel={this.closeBeneficiaryAddressModal}
                                   finishSelectedAddress={this.onFinishSelectedAddress}/>
          {this.props.currentCustomer.isPartner && <OriginatorModal
              visible={this.state.isOriginatorModalVisible}
              currentCustomer={this.props.currentCustomer}
              industries={this.state.industries}
              onCompleted={this.submitOriginator}
              idTypes={this.state.idTypes}
              onCancel={this.closeOriginatorModal}
              mode={"new"}
          />}
        <div className="bp-page-body ">
          <div className="bp-bordered-panel">
            <Row className="bp-row" gutter={16}>
              <Col md={12} xs={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.setupbeneficiarytab.sendamount"})}
                  value={formatMoneyValue(this.props.payment.sourceValue)}
                />
              </Col>
              <Col md={12} xs={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.setupbeneficiarytab.beneficiarygets"})}
                  value={formatMoneyValue(this.props.payment.targetValue)}
                />
              </Col>
            </Row>
          </div>
        </div>

          {/*{this.state.errorMsgOverLimit &&
          <div >
              <Alert style={{display: "table", whiteSpace: "wrap", marginTop: "5px"}}
                     message={this.state.errorMsgOverLimit} type="error"/>
              <Alert style={{display: "inline-block", whiteSpace: "wrap", marginTop: "5px"}}
                     message="Please contact support (operations@brdgx.com) for preferential rates and transfer procedure." type="error"/>
          </div>
          }*/}

          {/*----ORIGINATOR--------*/}
          {this.buildOriginatorData(originators, selectedOriginator)}
          {this.state.warningMsgCcy && <Alert style={{marginBottom: 10}} type="warning" message={this.state.warningMsgCcy} />}
        {/*----BENEFICIARY--------*/}
           {this.buildBeneficiaryData(beneficiaries,selectedBeneficiary)}

        <div className="bp-padded-top-panel bp-buttons-panel">
          <Button
              htmlType={"button"}
              size="large"
              className="bt-skip btn-wide-md"
              onClick={this.props.onBack}
          >
            <FormattedMessage id="app.panel.setupbeneficiarytab.back"/>
          </Button>
          <Button
              htmlType={"button"}
              type="primary"
              size="large"
              disabled={disabledNext}
              className="btn-wide-md"
              onClick={this.onNextButtonClick}
          >
            <FormattedMessage id="app.panel.setupbeneficiarytab.next"/>
          </Button>
        </div>

      </>
    );
  }

  onOriginatorSearch =(originator) =>{
    var array = [];
    array.push(originator);
    this.setState({
        originators: array,
        originatorsTotal: 1,
        isLoading: false
    });

}

onBeneficiarySearch =(beneficairy) =>{
    var array = [];
    array.push(beneficairy);
    this.setState({
        beneficiaries: array,
        beneficiariesTotal: 1,
        isLoading: false
    });

}

    buildOriginatorData(originators, selectedOriginator) {
        if (this.props.currentCustomer.isPartner) {
            return (
                <>
                    <div className={"headline-page"}>
                        <h4 className="bp-page-headline"><FormattedMessage id="app.panel.setupbeneficiarytab.whoisyoursender"/></h4>
                        <Button
                            htmlType={"button"}
                            type="primary"
                            onClick={this.onAddOriginatorClicked}
                        >
                            <FormattedMessage id="app.panel.setupbeneficiarytab.addnewsender"/>
                        </Button>
                    </div>
                    <div className="bp-page-body setup-beneficiary-tab">
                        <div>
                            <Row gutter={{xs: 4, sm: 8}}>
                                <Col md={{span: 8}} xs={{span: 18}}>
                                    <OriginatorSelectionComponent onChange={e=>this.onFieldChanged('originatorNameSearch', e)}  
                                        onSelected={originator => this.onOriginatorSearch(originator)}
                                        onClear={() => {
                                            this.refreshOriginatorsList();
                                        }}/>
                                </Col>
                            </Row>
                        </div>
                        <br/>

                        <RadioGroup
                            className="beneficiary-radio-group bp-radio-custom"
                            value={this.state.senderUsingCustomerAccount ? 'SELF' : (selectedOriginator && selectedOriginator.id)}
                            onChange={event => {
                                this.onOriginatorSelected(event.target.value);
                                this.setState({
                                    selectedOriginatorVAId:null
                                })
                            }}
                        >   
                            
                            <SelectableRadioPanel
                                radioKey={'SELF'}
                                key={'SELF'}
                                render={() => {
                                    return (
                                        <CustomerAccountDetailsPanel currentCustomer={this.props.currentCustomer}/>
                                    );
                                }}
                                
                            />
                            <br/>
                            
                            {/* Checking when is have no any item */}
                            {originators.length === 0 && (
                                <div className={"empty-item-block"}>
                                    <FormattedMessage id="app.message.setupbeneficiarytab.donthavesender"/>
                                </div>
                            )}

                            {originators.map((originator,idx) => {


                                let disabledSelectOrig = this.state.disabledAll || this.state.originators.includes(originator.id);
                                return (
                                    <>
                                        <SelectableRadioPanel
                                            disabled={disabledSelectOrig }
                                            radioKey={originator.id}
                                            key={originator.id}
                                            render={() => {
                                                return (
                                                    <OriginatorDetailsPanel originator={originator}
                                                                             onSelectOrigVa={this.onSelectOrigVa}
                                                                             disabledOrig={disabledSelectOrig}
                                                                             sourceCurrency={this.props.payment.sourceValue.currency}
                                                                            idxOfCurrentItem={idx}
                                                                            updateOriginator={(idx,newData) => {
                                                                                let orgs = this.state.originators;
                                                                                orgs[idx] = newData;
                                                                                this.setState({
                                                                                    originators:orgs
                                                                                })
                                                                            }}
                                                                             targetCurrency={this.props.payment.targetValue.currency}
                                                                             selectedOriginatorVAId={this.state.selectedOriginatorVAId}
                                                    />
                                                );
                                            }}
                                        />
                                    </>
                                );
                            })}
                        </RadioGroup>
                        <div style={{float: "right", marginBottom: "10px", marginTop: "-10px"}}>
                            <Pagination
                                defaultCurrent={this.state.currentPageOriginator + 1}
                                current={this.state.currentPageOriginator+1}
                                onChange={(nextPage) => {
                                    this.getNextOriginatorPage(nextPage - 1);
                                }}
                                pageSize={DEFAULT_PAGE_SIZE_5}
                                total={this.state.originatorsTotal}
                            />
                        </div>
                    </div>
                </>
            );
        }
        return null;
    }

    onSelectBeneVa = (beneVa,beneId) =>{
        this.setState({
            selectedBeneficiaryVAId:beneVa
        })
        this.onBeneficiarySelected(beneId);
    }

    onSelectOrigVa = (org,origId) =>{
        this.setState({
            selectedOriginatorVAId:org
        })
        this.onOriginatorSelected(origId);
    }

    buildBeneficiaryData(beneficiaries,selectedBeneficiary){
        if (this.state.isBeneficiaryLoading) {
            return <LoadingIndicator />;
        }
        let isPartner = this.props.currentCustomer.isPartner;
        let isSenderSelected = (this.state.senderUsingCustomerAccount || this.state.selectedOriginator);
      if((isPartner && isSenderSelected) || !isPartner) {
          return (
              <>
                  <div className={"headline-page"}>
                      <h4 className="bp-page-headline"><FormattedMessage id="app.panel.setupbeneficiarytab.whoareyousendingto"/></h4>
                      <Button
                          htmlType={"button"}
                          type="primary"
                          onClick={this.onAddBeneficiaryClicked}
                      >
                          <FormattedMessage id="app.panel.setupbeneficiarytab.addnewbeneficiary"/>
                      </Button>
                  </div>
                  <div className="bp-page-body setup-beneficiary-tab">
                        <div>
                            <Row gutter={{xs: 4, sm: 8}}>
                                <Col md={{span: 8}} xs={{span: 18}}>
                                    <BeneficiarySelectionComponent onChange={e=>this.onFieldChanged('beneficiaryNameSearch', e)}  
                                        onSelected={beneficiary => this.onBeneficiarySearch(beneficiary)}
                                        originatorId={(this.state.selectedOriginator) ? this.state.selectedOriginator.id : null}
                                         beneficiaryCountry={this.props.payment.beneficiaryCountry}
                                         sourceCurrency={this.props.payment.sourceValue.currency}
                                         targetCurrency={this.props.payment.targetValue.currency}
                                        onClear={() => {
                                            this.refreshBeneficiariesList();
                                        }}/>
                                </Col>
                            </Row>
                        </div>
                        <br/>

                      <RadioGroup
                          className="beneficiary-radio-group bp-radio-custom"
                          value={selectedBeneficiary && selectedBeneficiary.id}
                          onChange={event => {
                              this.onBeneficiarySelected(event.target.value);
                              this.setState({
                                  selectedBeneficiaryVAId:null
                              })
                          }}
                      >
                          {/* Checking when is have no any item */}
                          {beneficiaries.length === 0 && (
                              <div className={"empty-item-block"}>
                                  <FormattedMessage id="app.message.setupbeneficiarytab.donthavebeneficiary"/>
                              </div>
                          )}

                          {beneficiaries.map(beneficiary => {
                              if(beneficiary.transferCurrencies) {
                                  let disabledSelect = this.state.disabledAll || !beneficiary.transferCurrencies.includes(this.props.payment.targetValue.currency) ;
                                  return (
                                      <>
                                          <SelectableRadioPanel
                                              disabled={disabledSelect}
                                              radioKey={beneficiary.id}
                                              key={beneficiary.id}
                                              render={() => {
                                                  return (
                                                      <BeneficiaryDetailsPanel beneficiary={beneficiary}
                                                      onSelectBeneVa={this.onSelectBeneVa}
                                                      disabledBene={disabledSelect}
                                                      sourceCurrency={this.props.payment.sourceValue.currency}
                                                      targetCurrency={this.props.payment.targetValue.currency}
                                                      selectedBeneficiaryVAId={this.state.selectedBeneficiaryVAId}
                                                      />
                                                  );
                                              }}
                                          />
                                      </>
                                  );
                              }else {
                                  let disabledSelect = this.state.disabledAll || (!this.state.validBankCountryList.includes(beneficiary.bankCountry) && this.props.payment.targetValue.currency !== 'USD');
                                  return (
                                      <>
                                          <SelectableRadioPanel
                                              disabled={disabledSelect}
                                              radioKey={beneficiary.id}
                                              key={beneficiary.id}
                                              render={() => {
                                                  return (
                                                      <BeneficiaryDetailsPanel beneficiary={beneficiary}/>
                                                  );
                                              }}
                                          />
                                      </>
                                  );
                              }
                          })}
                      </RadioGroup>
                      <div style={{float:"right", marginBottom: "10px", marginTop: "-10px"}}>
                          <Pagination
                              defaultCurrent={this.state.currentPageBeneficiary+1}
                              current={this.state.currentPageBeneficiary+1}
                              onChange={(nextPage)=>{
                                  this.getNextBeneficiaryPage(nextPage-1);
                              }}
                              pageSize={DEFAULT_PAGE_SIZE_5}
                              total={this.state.beneficiariesTotal}
                          />
                      </div>
                  </div>
              </>
          )
      }

    }
}

export default withUseIntl(SetupBeneficiaryTab);